import axios from 'axios'
import router from '@/router'
import store from '@/store'
import { Message, MessageBox, Loading, Notification } from 'element-ui'
// ... existing code ...
import { i18n } from '@/utils/i18n/index.js'
import { tansParams, blobValidate } from '@/utils/ruoyi';
import { saveAs } from 'file-saver'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 30,
})
// 是否显示重新登录
export let isRelogin = {
  show: false,
}

let loadingInstance
instance.interceptors.request.use(
  (config) => {
	  
	const token = store.getters.token
	if (config.headers.isToken !== false && token) config.headers['Authorization'] = 'Bearer ' + token
	config.headers['Content-Type'] = 'application/json'
	// config.headers['Origin'] = 'https://v6.51.1a'
	// config.headers['Referer'] = 'https://v6.51.1a/'
	
	if(!config.headers['content-language']){
		config.headers['content-language'] = i18n.locale
	}else{
		// console.log('预设配置', config.headers)
	}
	if (config.headers.needLoading !== false) {
		loadingInstance = Loading.service({
			lock: true,
			text: i18n.locale == 'zh_CN'?'加载资源中...':'loading...',
			spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255, 0.6)',
		})
	}
	config.headers.clientid = 'e5cd7e4891bf95d1d19206ce24a7b32e'
	return config

  },
  (err) => {
    if (err.config.headers.needLoading !== false) loadingInstance.close()
    return Promise.reject(err)
  },
)

// 响应拦截
instance.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.msg || '连接失败'
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (res.config.headers.needLoading !== false) loadingInstance.close()
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        MessageBox.confirm(i18n.t('login.未登录或登录过期，请重新登录'), i18n.t('login.提示'), {
          confirmButtonText: i18n.t('login.登录'),
          cancelButtonText: i18n.t('login.取消'),
          type: 'warning',
        })
          .then(() => {
            isRelogin.show = false
            store.dispatch('LogOut').then((res) => {
              location.href = '/login'
            })
          })
          .catch(() => {
            isRelogin.show = false
          })
        return res.data
      } else {
        return res.data
      }
      return Promise.reject('未登录或登录过期，请重新登录。')
    } else if (code === 500) {
      Message({
        message: msg.length > 50 ? '请求失败，请稍后再试。' : msg,
        type: 'error',
      })
      // return Promise.reject(new Error(msg))
      return res.data
    } else {
      return res.data
    }
  },
  (err) => {
    if (err.config.headers.needLoading !== false) {
      setTimeout(() => {
        loadingInstance.close()
      }, 1000)
    }
    return Promise.reject(err)
    // return console.log('接口报错', err)
  },
)
// 通用下载方法
export function download(url, params, filename, config) {
  let downloadLoadingInstance = Loading.service({
    text: '正在下载数据，请稍候',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  return instance
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params)
        },
      ],
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
      ...config,
    })
    .then(async (data) => {
      const isBlob = blobValidate(data)
      if (isBlob) {
        const blob = new Blob([data])
        saveAs(blob, filename)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        Message.error(errMsg)
      }
      downloadLoadingInstance.close()
    })
    .catch((r) => {
      console.error(r)
      Message.error('下载文件出现错误，请联系管理员！')
      downloadLoadingInstance.close()
    })
}
window.$axios = instance
export default instance
